import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src316224838/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/information/content.tsx");
